import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { UpdateMasterLokasiInterviewById } from "../../../GQL/mutations";
import { useApolloClient } from "@apollo/client/react";
import { FullScreenLoading } from "@mostrans/web-components/components/base/Loading";
import { toast, ToastContainer } from "react-toastify";

function ModalDetailOfficeLoc(props) {
  const {
    openModalDetailOffice,
    handleCloseModalDetailOffice,
    detailOfficeLocation,
    disableButton,
    setDisableButton,
    errInput,
    setErrInput,
    fetchMasterLokasiInterview,
  } = props;
  const [valueUpdateOffice, setValueUpdateOffice] = useState({
    id: null,
    nama: "",
    alamat: "",
  });
  const client = useApolloClient();
  const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);

  useEffect(() => {
    setValueUpdateOffice({
      id: detailOfficeLocation?.id,
      nama: detailOfficeLocation?.nama,
      alamat: detailOfficeLocation?.alamat,
    });
  }, [openModalDetailOffice]);

  const submitUpdateOfficeLoc = async () => {
    const paramUpdateOffice = {
      id: detailOfficeLocation?.id,
      nama: valueUpdateOffice.nama,
      alamat: valueUpdateOffice.alamat,
    };
    if (valueUpdateOffice.nama === "" || valueUpdateOffice.alamat === "") {
      return setErrInput(true);
    }
    try {
      setIsFullScreenLoading(true);
      const response = await UpdateMasterLokasiInterviewById(
        client,
        paramUpdateOffice
      );
      if (response.data.updateMasterLokasiInterviewById.errMsg === "OK") {
        toast.success("Office Location Updated", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsFullScreenLoading(false);
        fetchMasterLokasiInterview();
        handleCloseModalDetailOffice();
      } else {
        toast.error(response.data.updateMasterLokasiInterviewById.errMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsFullScreenLoading(false);
      }
    } catch (error) {
      alert(error);
    }
  };
  return (
    <React.Fragment>
      <FullScreenLoading
        show={isFullScreenLoading}
        backdropProps={{ style: { zIndex: 10000 } }}
      />
      <Dialog
        open={openModalDetailOffice}
        onClose={handleCloseModalDetailOffice}
      >
        <DialogTitle>Update Office Location</DialogTitle>
        <DialogContent>
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Office Name is required</p>
                }
                isError={errInput && !valueUpdateOffice.nama}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Office Name
                </label>
                <Input
                  type="text"
                  defaultValue={detailOfficeLocation.nama}
                  style={{ width: "500px" }}
                  onChange={(e) => {
                    setValueUpdateOffice({
                      ...valueUpdateOffice,
                      nama: e.target.value,
                    });
                    setDisableButton(false);
                  }}
                />
              </FormGroup>
            </div>
          </div>
          <div className="form-row mb-1">
            <div className="col-md-12">
              <FormGroup
                isRequired
                placement="vertical"
                errorMessage={
                  <p style={{ fontSize: 13 }}>Office Address is required</p>
                }
                isError={errInput && !valueUpdateOffice.alamat}
                showChildErrorSign
              >
                <label htmlFor="" style={{ fontSize: 12 }}>
                  Office Address
                </label>
                <Input
                  defaultValue={detailOfficeLocation.alamat}
                  multiline
                  type="text"
                  onChange={(e) => {
                    setValueUpdateOffice({
                      ...valueUpdateOffice,
                      alamat: e.target.value,
                    });
                    setDisableButton(false);
                  }}
                />
              </FormGroup>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={handleCloseModalDetailOffice}>
            Cancel
          </Button>
          <Button disabled={disableButton} onClick={submitUpdateOfficeLoc}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ModalDetailOfficeLoc;
